<app-dialog
  [dialogType]="dialogType"
  [headerLabel]="'DIALOG.POPUP_BLOCKED.TITLE' | translate"
  [primaryActionText]="'ACTION.OK' | translate"
>
  <p class="popup-blocked-prompt">
    {{ 'DIALOG.POPUP_BLOCKED.PROMPT' | translate }}
  </p>
</app-dialog>
